import React from 'react';
import { FormattedMessage } from 'react-intl';

import { showLoginModal } from '../authInterface';

import styles from './DeniedAccessMessages.scss';

export function BlacklistedMessage() {
    return (
        <div className={styles.messageContainer}>
            <FormattedMessage
                id="shared.DeniedAccessMessages.blacklisted"
                defaultMessage="Sorry, you do not have access to this page. Please contact trade@1stdibs.com if we can help you with anything."
            />
        </div>
    );
}

export function FirmEnrolledMessage() {
    return (
        <div className={styles.messageContainer} data-tn="enrolled-label">
            <FormattedMessage
                id="shared.DeniedAccessMessages.firmEnrolled[0]"
                defaultMessage="Your firm is already enrolled in our loyalty program. View your firm activity in {link}"
                values={{
                    link: (
                        <a href="/trade/loyalty/rewards/" data-tn="enrolled-cta">
                            <FormattedMessage
                                id="shared.DeniedAccessMessages.firmEnrolled[1]"
                                defaultMessage="Rewards."
                            />
                        </a>
                    ),
                }}
            />
        </div>
    );
}

export function NotEligibleMessage() {
    return (
        <div className={styles.messageContainer} data-tn="not-eligible-label">
            <FormattedMessage
                id="shared.DeniedAccessMessages.notEligible[0]"
                defaultMessage="Your firm is not yet signed up for our loyalty program. If you would like to sign up for our program, please contact {email}"
                values={{
                    email: (
                        <span className={styles.emphasis}>
                            <FormattedMessage
                                id="shared.DeniedAccessMessages.notEligible[1]"
                                defaultMessage="trade@1stdibs.com"
                            />
                        </span>
                    ),
                }}
            />
        </div>
    );
}

export function NotLoggedInMessage() {
    return (
        <div className={styles.messageContainer} data-tn="logged-out-label">
            <FormattedMessage
                id="shared.DeniedAccessMessages.notLoggedIn[0]"
                defaultMessage="You need to be logged in to see this page. Please {loginLink}"
                values={{
                    loginLink: (
                        <a
                            className={styles.link}
                            onClick={showLoginModal}
                            data-tn="logged-out-cta"
                        >
                            <FormattedMessage
                                id="shared.DeniedAccessMessages.notLoggedIn[1]"
                                defaultMessage="login."
                            />
                        </a>
                    ),
                }}
            />
        </div>
    );
}

export function NotTradeMessage() {
    return (
        <div className={styles.messageContainer} data-tn="non-trade-label">
            <FormattedMessage
                id="shared.DeniedAccessMessages.notTrade[0]"
                defaultMessage="Sorry, this page is for members of our trade program. If you are an interior designer or architect, please {applyLink} for the program."
                values={{
                    applyLink: (
                        <a href="/trade/apply/" data-tn="non-trade-cta">
                            <FormattedMessage
                                id="shared.DeniedAccessMessages.notTrade[1]"
                                defaultMessage="apply"
                            />
                        </a>
                    ),
                }}
            />
        </div>
    );
}
